// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --chlk-dark: #1E1E1E;
  --chlk-blue: #2B76BA;
  --chlk-light: #D6F1FF;
  --chlk-cream: #FCFAF5;
}

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 13px;
  color: var(--chlk-dark);
  background: var(--chlk-cream);
  height: 100vh;
  overflow: hidden;
}

.app { display: flex; flex-direction: column; height: 100vh; }

.loading { display: flex; align-items: center; justify-content: center; height: 100vh; color: #888; }

.banner-error {
  background: #fde;
  color: #c00;
  padding: 8px 12px;
  font-size: 12px;
  cursor: pointer;
  border-bottom: 1px solid #fbb;
}

/* Login */
.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;
  padding: 24px;
  gap: 20px;
  background: var(--chlk-cream);
  overflow-y: auto;
}
.login-logo {
  display: block;
  height: 40px;
  width: auto;
}
.login-tagline {
  font-size: 13px;
  color: #555;
  text-align: center;
  max-width: 280px;
  line-height: 1.5;
}
.login-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 280px;
}
.login-form label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: #555;
}
.login-form input {
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
  outline: none;
  background: #fff;
}
.login-form input:focus { border-color: var(--chlk-blue); }
.login-form button {
  padding: 9px;
  background: var(--chlk-blue);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 4px;
}
.login-form button:disabled { opacity: 0.5; cursor: not-allowed; }
.form-error { color: #c00; font-size: 12px; }

/* Social sign-in */
.login-social {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 280px;
}
.btn-social {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid #ccc;
  background: #fff;
  color: var(--chlk-dark);
  transition: background 0.15s, border-color 0.15s;
}
.btn-social:hover:not(:disabled) {
  background: #f5f5f5;
  border-color: #aaa;
}
.btn-social:disabled { opacity: 0.5; cursor: not-allowed; }
.btn-apple {
  background: #000;
  color: #fff;
  border-color: #000;
}
.btn-apple:hover:not(:disabled) {
  background: #222;
  border-color: #222;
}
.social-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.login-divider {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 280px;
  gap: 12px;
  color: #888;
  font-size: 12px;
}
.login-divider::before,
.login-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #ddd;
}

/* Browser */
.browser { display: flex; flex-direction: column; height: 100vh; background: var(--chlk-cream); }
.browser-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid #333;
  flex-shrink: 0;
  background: var(--chlk-dark);
}
.browser-logo {
  display: block;
  height: 22px;
  width: auto;
}
.btn-logout {
  font-size: 11px;
  color: #ccc;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 0;
}
.btn-logout:hover { color: var(--chlk-light); }
.browser-search {
  padding: 8px 12px;
  border-bottom: 1px solid #e5e5e5;
  flex-shrink: 0;
  background: var(--chlk-cream);
}
.browser-search-input {
  width: 100%;
  padding: 7px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
  outline: none;
  background: #fff;
}
.browser-search-input:focus { border-color: var(--chlk-blue); }
.browser-body {
  display: flex;
  flex: 1;
  overflow: hidden;
}

/* Folder list */
.folder-list {
  width: 120px;
  flex-shrink: 0;
  border-right: 1px solid #e5e5e5;
  overflow-y: auto;
  padding: 8px 0;
  background: var(--chlk-cream);
}
.folder-item {
  padding: 7px 12px;
  cursor: pointer;
  font-size: 12px;
  color: #444;
  border-left: 3px solid transparent;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.folder-item:hover { background: var(--chlk-light); }
.folder-item.selected {
  border-left-color: var(--chlk-blue);
  font-weight: 600;
  color: var(--chlk-dark);
  background: var(--chlk-light);
}
.loading-text { padding: 12px; color: #888; font-size: 12px; }
.folder-error {
  padding: 12px;
  font-size: 11px;
  color: #c00;
  line-height: 1.4;
}

/* Play grid panel */
.play-grid-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}
.selection-bar {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid #e5e5e5;
  background: var(--chlk-light);
  flex-shrink: 0;
}
.selection-count {
  font-size: 11px;
  font-weight: 600;
  color: #555;
}
.selection-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.btn-selection-primary {
  padding: 6px 10px;
  background: var(--chlk-blue);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.btn-selection-primary:disabled { opacity: 0.5; cursor: not-allowed; }
.btn-selection {
  padding: 6px 10px;
  background: #fff;
  color: var(--chlk-dark);
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.btn-selection:disabled { opacity: 0.5; cursor: not-allowed; }
.bulk-banner {
  padding: 8px 10px;
  font-size: 11px;
  flex-shrink: 0;
}
.bulk-banner.success {
  background: #ecfdf5;
  color: #065f46;
  border-bottom: 1px solid #a7f3d0;
}
.bulk-banner.error {
  background: #fde;
  color: #c00;
  border-bottom: 1px solid #fbb;
}

/* Play grid */
.play-grid {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  padding: 10px;
  align-content: start;
}
.play-grid-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  font-size: 12px;
  padding: 20px;
}
.error-text { color: #c00; }

/* Play card */
.play-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 8px;
  background: var(--chlk-cream);
}
.play-card.selected {
  border-color: var(--chlk-blue);
  background: var(--chlk-light);
}
.play-card-select {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 1;
  cursor: pointer;
}
.play-card-select input {
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.play-card-thumb {
  aspect-ratio: 1200 / 959;
  background: #eee;
  border-radius: 4px;
  overflow: hidden;
}
.play-card-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.thumb-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #e8e8e8 25%, #ddd 50%, #e8e8e8 75%);
}
.thumb-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: #fde;
  color: #c00;
  font-size: 10px;
  text-align: center;
  line-height: 1.3;
}
.play-card-name {
  font-size: 11px;
  font-weight: 600;
  color: var(--chlk-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.play-card-error { font-size: 10px; color: #c00; }
.btn-insert {
  padding: 5px 0;
  background: var(--chlk-blue);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
}
.btn-insert:disabled { opacity: 0.5; cursor: not-allowed; }

/* Error boundary */
.error-boundary {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 24px;
  gap: 12px;
  text-align: center;
  background: var(--chlk-cream);
  color: var(--chlk-dark);
}
.error-boundary-title {
  font-size: 14px;
  font-weight: 600;
}
.error-boundary-message {
  font-size: 12px;
  color: #666;
  max-width: 260px;
  line-height: 1.4;
}
.error-boundary button {
  padding: 8px 16px;
  background: var(--chlk-blue);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

/* Mask editor */
.mask-panel {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: var(--chlk-cream);
}
.mask-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-bottom: 1px solid #e5e5e5;
  background: var(--chlk-dark);
  color: #fff;
  flex-shrink: 0;
}
.mask-title {
  font-size: 14px;
  font-weight: 700;
}
.mask-subtitle {
  font-size: 11px;
  color: #ccc;
  margin-top: 2px;
}
.btn-mask-done {
  padding: 6px 12px;
  background: var(--chlk-blue);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.btn-mask-done:disabled { opacity: 0.5; cursor: not-allowed; }
.mask-preview {
  position: relative;
  flex: 1;
  margin: 12px;
  border: 2px solid var(--chlk-dark);
  border-radius: 6px;
  overflow: hidden;
  background: #111;
  cursor: grab;
  touch-action: none;
  min-height: 180px;
}
.mask-preview.dragging { cursor: grabbing; }
.mask-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  user-select: none;
  pointer-events: none;
}
.mask-preview-placeholder {
  width: 100%;
  height: 100%;
  min-height: 180px;
  background: #222;
}
.mask-preview-hint {
  position: absolute;
  bottom: 8px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 10px;
  color: rgba(255, 255, 255, 0.7);
  background: rgba(0, 0, 0, 0.5);
  padding: 3px 8px;
  border-radius: 10px;
  pointer-events: none;
}
.mask-controls {
  padding: 0 12px 12px;
  flex-shrink: 0;
}
.mask-zoom-label {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 6px;
  color: var(--chlk-dark);
}
.mask-zoom-value { color: var(--chlk-blue); }
.mask-zoom-slider {
  width: 100%;
  accent-color: var(--chlk-blue);
}
.mask-error {
  margin: 0 12px 8px;
  padding: 8px;
  background: #fde;
  color: #c00;
  font-size: 11px;
  border-radius: 4px;
}
.mask-status {
  padding: 0 12px 12px;
  font-size: 11px;
  color: #666;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/styles/taskpane.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE;EACE,sEAAsE;EACtE,eAAe;EACf,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;AAClB;;AAEA,OAAO,aAAa,EAAE,sBAAsB,EAAE,aAAa,EAAE;;AAE7D,WAAW,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,aAAa,EAAE,WAAW,EAAE;;AAEpG;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA,0BAA0B,8BAA8B,EAAE;AAC1D;EACE,YAAY;EACZ,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA,8BAA8B,YAAY,EAAE,mBAAmB,EAAE;AACjE,cAAc,WAAW,EAAE,eAAe,EAAE;;AAE5C,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,gDAAgD;AAClD;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;AAC1D;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,OAAO;EACP,WAAW;EACX,gBAAgB;AAClB;;AAEA,YAAY;AACZ,WAAW,aAAa,EAAE,sBAAsB,EAAE,aAAa,EAAE,6BAA6B,EAAE;AAChG;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA,oBAAoB,wBAAwB,EAAE;AAC9C;EACE,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA,8BAA8B,8BAA8B,EAAE;AAC9D;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,qBAAqB,6BAA6B,EAAE;AACpD;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA,gBAAgB,aAAa,EAAE,WAAW,EAAE,eAAe,EAAE;AAC7D;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gCAAgC;EAChC,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;AACrE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;AAC7D;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;AAEA,cAAc;AACd;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,aAAa;AACf;AACA,cAAc,WAAW,EAAE;;AAE3B,cAAc;AACd;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uEAAuE;AACzE;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA,mBAAmB,eAAe,EAAE,WAAW,EAAE;AACjD;EACE,cAAc;EACd,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;;AAE1D,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,WAAW;EACX,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,0BAA0B,YAAY,EAAE,mBAAmB,EAAE;AAC7D;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;AACA,yBAAyB,gBAAgB,EAAE;AAC3C;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA,mBAAmB,uBAAuB,EAAE;AAC5C;EACE,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb","sourcesContent":[":root {\n  --chlk-dark: #1E1E1E;\n  --chlk-blue: #2B76BA;\n  --chlk-light: #D6F1FF;\n  --chlk-cream: #FCFAF5;\n}\n\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  font-size: 13px;\n  color: var(--chlk-dark);\n  background: var(--chlk-cream);\n  height: 100vh;\n  overflow: hidden;\n}\n\n.app { display: flex; flex-direction: column; height: 100vh; }\n\n.loading { display: flex; align-items: center; justify-content: center; height: 100vh; color: #888; }\n\n.banner-error {\n  background: #fde;\n  color: #c00;\n  padding: 8px 12px;\n  font-size: 12px;\n  cursor: pointer;\n  border-bottom: 1px solid #fbb;\n}\n\n/* Login */\n.login {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100vh;\n  padding: 24px;\n  gap: 20px;\n  background: var(--chlk-cream);\n  overflow-y: auto;\n}\n.login-logo {\n  display: block;\n  height: 40px;\n  width: auto;\n}\n.login-tagline {\n  font-size: 13px;\n  color: #555;\n  text-align: center;\n  max-width: 280px;\n  line-height: 1.5;\n}\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  max-width: 280px;\n}\n.login-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n}\n.login-form input {\n  padding: 8px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 13px;\n  outline: none;\n  background: #fff;\n}\n.login-form input:focus { border-color: var(--chlk-blue); }\n.login-form button {\n  padding: 9px;\n  background: var(--chlk-blue);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-top: 4px;\n}\n.login-form button:disabled { opacity: 0.5; cursor: not-allowed; }\n.form-error { color: #c00; font-size: 12px; }\n\n/* Social sign-in */\n.login-social {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  max-width: 280px;\n}\n.btn-social {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 10px 16px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid #ccc;\n  background: #fff;\n  color: var(--chlk-dark);\n  transition: background 0.15s, border-color 0.15s;\n}\n.btn-social:hover:not(:disabled) {\n  background: #f5f5f5;\n  border-color: #aaa;\n}\n.btn-social:disabled { opacity: 0.5; cursor: not-allowed; }\n.btn-apple {\n  background: #000;\n  color: #fff;\n  border-color: #000;\n}\n.btn-apple:hover:not(:disabled) {\n  background: #222;\n  border-color: #222;\n}\n.social-icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n.login-divider {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 280px;\n  gap: 12px;\n  color: #888;\n  font-size: 12px;\n}\n.login-divider::before,\n.login-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #ddd;\n}\n\n/* Browser */\n.browser { display: flex; flex-direction: column; height: 100vh; background: var(--chlk-cream); }\n.browser-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-bottom: 1px solid #333;\n  flex-shrink: 0;\n  background: var(--chlk-dark);\n}\n.browser-logo {\n  display: block;\n  height: 22px;\n  width: auto;\n}\n.btn-logout {\n  font-size: 11px;\n  color: #ccc;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px 0;\n}\n.btn-logout:hover { color: var(--chlk-light); }\n.browser-search {\n  padding: 8px 12px;\n  border-bottom: 1px solid #e5e5e5;\n  flex-shrink: 0;\n  background: var(--chlk-cream);\n}\n.browser-search-input {\n  width: 100%;\n  padding: 7px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n  outline: none;\n  background: #fff;\n}\n.browser-search-input:focus { border-color: var(--chlk-blue); }\n.browser-body {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Folder list */\n.folder-list {\n  width: 120px;\n  flex-shrink: 0;\n  border-right: 1px solid #e5e5e5;\n  overflow-y: auto;\n  padding: 8px 0;\n  background: var(--chlk-cream);\n}\n.folder-item {\n  padding: 7px 12px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #444;\n  border-left: 3px solid transparent;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.folder-item:hover { background: var(--chlk-light); }\n.folder-item.selected {\n  border-left-color: var(--chlk-blue);\n  font-weight: 600;\n  color: var(--chlk-dark);\n  background: var(--chlk-light);\n}\n.loading-text { padding: 12px; color: #888; font-size: 12px; }\n.folder-error {\n  padding: 12px;\n  font-size: 11px;\n  color: #c00;\n  line-height: 1.4;\n}\n\n/* Play grid panel */\n.play-grid-panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 0;\n}\n.selection-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 10px;\n  border-bottom: 1px solid #e5e5e5;\n  background: var(--chlk-light);\n  flex-shrink: 0;\n}\n.selection-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: #555;\n}\n.selection-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n.btn-selection-primary {\n  padding: 6px 10px;\n  background: var(--chlk-blue);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.btn-selection-primary:disabled { opacity: 0.5; cursor: not-allowed; }\n.btn-selection {\n  padding: 6px 10px;\n  background: #fff;\n  color: var(--chlk-dark);\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.btn-selection:disabled { opacity: 0.5; cursor: not-allowed; }\n.bulk-banner {\n  padding: 8px 10px;\n  font-size: 11px;\n  flex-shrink: 0;\n}\n.bulk-banner.success {\n  background: #ecfdf5;\n  color: #065f46;\n  border-bottom: 1px solid #a7f3d0;\n}\n.bulk-banner.error {\n  background: #fde;\n  color: #c00;\n  border-bottom: 1px solid #fbb;\n}\n\n/* Play grid */\n.play-grid {\n  flex: 1;\n  overflow-y: auto;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  padding: 10px;\n  align-content: start;\n}\n.play-grid-empty {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #888;\n  font-size: 12px;\n  padding: 20px;\n}\n.error-text { color: #c00; }\n\n/* Play card */\n.play-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  border: 1px solid #e5e5e5;\n  border-radius: 6px;\n  padding: 8px;\n  background: var(--chlk-cream);\n}\n.play-card.selected {\n  border-color: var(--chlk-blue);\n  background: var(--chlk-light);\n}\n.play-card-select {\n  position: absolute;\n  top: 6px;\n  left: 6px;\n  z-index: 1;\n  cursor: pointer;\n}\n.play-card-select input {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n}\n.play-card-thumb {\n  aspect-ratio: 1200 / 959;\n  background: #eee;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.play-card-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.thumb-placeholder {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #e8e8e8 25%, #ddd 50%, #e8e8e8 75%);\n}\n.thumb-error {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  background: #fde;\n  color: #c00;\n  font-size: 10px;\n  text-align: center;\n  line-height: 1.3;\n}\n.play-card-name {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--chlk-dark);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.play-card-error { font-size: 10px; color: #c00; }\n.btn-insert {\n  padding: 5px 0;\n  background: var(--chlk-blue);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  width: 100%;\n}\n.btn-insert:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* Error boundary */\n.error-boundary {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  padding: 24px;\n  gap: 12px;\n  text-align: center;\n  background: var(--chlk-cream);\n  color: var(--chlk-dark);\n}\n.error-boundary-title {\n  font-size: 14px;\n  font-weight: 600;\n}\n.error-boundary-message {\n  font-size: 12px;\n  color: #666;\n  max-width: 260px;\n  line-height: 1.4;\n}\n.error-boundary button {\n  padding: 8px 16px;\n  background: var(--chlk-blue);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n/* Mask editor */\n.mask-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background: var(--chlk-cream);\n}\n.mask-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  border-bottom: 1px solid #e5e5e5;\n  background: var(--chlk-dark);\n  color: #fff;\n  flex-shrink: 0;\n}\n.mask-title {\n  font-size: 14px;\n  font-weight: 700;\n}\n.mask-subtitle {\n  font-size: 11px;\n  color: #ccc;\n  margin-top: 2px;\n}\n.btn-mask-done {\n  padding: 6px 12px;\n  background: var(--chlk-blue);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n.btn-mask-done:disabled { opacity: 0.5; cursor: not-allowed; }\n.mask-preview {\n  position: relative;\n  flex: 1;\n  margin: 12px;\n  border: 2px solid var(--chlk-dark);\n  border-radius: 6px;\n  overflow: hidden;\n  background: #111;\n  cursor: grab;\n  touch-action: none;\n  min-height: 180px;\n}\n.mask-preview.dragging { cursor: grabbing; }\n.mask-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  user-select: none;\n  pointer-events: none;\n}\n.mask-preview-placeholder {\n  width: 100%;\n  height: 100%;\n  min-height: 180px;\n  background: #222;\n}\n.mask-preview-hint {\n  position: absolute;\n  bottom: 8px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.7);\n  background: rgba(0, 0, 0, 0.5);\n  padding: 3px 8px;\n  border-radius: 10px;\n  pointer-events: none;\n}\n.mask-controls {\n  padding: 0 12px 12px;\n  flex-shrink: 0;\n}\n.mask-zoom-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 6px;\n  color: var(--chlk-dark);\n}\n.mask-zoom-value { color: var(--chlk-blue); }\n.mask-zoom-slider {\n  width: 100%;\n  accent-color: var(--chlk-blue);\n}\n.mask-error {\n  margin: 0 12px 8px;\n  padding: 8px;\n  background: #fde;\n  color: #c00;\n  font-size: 11px;\n  border-radius: 4px;\n}\n.mask-status {\n  padding: 0 12px 12px;\n  font-size: 11px;\n  color: #666;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
